import { render, staticRenderFns } from "./ReportsCollectionsTableWholesalers.vue?vue&type=template&id=104fb46c&scoped=true&"
import script from "./ReportsCollectionsTableWholesalers.vue?vue&type=script&lang=js&"
export * from "./ReportsCollectionsTableWholesalers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104fb46c",
  null
  
)

export default component.exports